module.exports = __webpack_public_path__ + "img/Logo2.0602674b.svg";